//Limitless imports
import { handleSecureAjaxError } from "../utils/SecurePlatformAPIUtils";
import { log as pilog } from "@limitless/common/utils";
import { getGraphQLClient } from "../clients/GraphQLClient";
import { GET_INBOX_ANNOUNCEMENTS } from "./queries/UserAnnouncementQueries";
import { isAnnouncementCriteriaMet, validateTemplateContent } from "../utils/AnnouncementsUtil";

/**
 * Find all the announcements for a particular user
 *
 * @param {function} callback
 */
export const fetchUserAnnouncements = callback => {
  const log = pilog.getLogger("UserAnnouncementsActions fetchUserAnnouncements");
  const graphQLClient = getGraphQLClient();
  graphQLClient.query({
    query: GET_INBOX_ANNOUNCEMENTS,
    fetchPolicy: "no-cache"
  }).then(response => {
    const announcementRecords = response.data.getInboxAnnouncements;
    log.debug({
      announcementRecords
    });
    const announcements = [];
    announcementRecords.map(announcement => {
      if (announcement.template && typeof announcement.template === "string") {
        announcement.template = validateTemplateContent(announcement);
      }

      //check if the platform/version is for this app
      if (!isAnnouncementCriteriaMet(announcement)) {
        log.debug("criteria not met!");
        return;
      }
      announcements.push(announcement);
    });
    callback({
      announcements
    });
  }).catch(error => {
    handleSecureAjaxError(error, "UserAnnouncementsActions fetchUserAnnouncements");
    callback({
      hasError: true,
      error
    });
  });
};